const target = document.querySelector('.floating-button');
const triggerHeight = getComputedStyle(document.body).getPropertyValue('--header-height') || '0';
const originalOffset = target.getBoundingClientRect().top + window.scrollY;


document.addEventListener('DOMContentLoaded',() => {  
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll + parseFloat(triggerHeight) >= originalOffset) {
			target.classList.add('is-fixed');
		} else {
			target.classList.remove('is-fixed');
		}
  });
})

